const blogPosts = [
  {
    title: "The Benefits of Ceramic Coatings",
    summary: "Discover why ceramic coatings are the best long-term protection for your vehicle's paint and how they compare to traditional waxes.",
    date: "April 15, 2023"
  },
  {
    title: "How to Maintain Your Car Between Details",
    summary: "Simple steps you can take to keep your vehicle looking great between professional detailing appointments.",
    date: "March 22, 2023"
  },
  {
    title: "Winter Car Care Tips",
    summary: "Protect your vehicle from Minnesota's harsh winter conditions with these essential care tips from our detailing experts.",
    date: "February 8, 2023"
  }
];

const BlogSection = () => (
  <section id="blog" className="mt-16 bg-white">
    <h3 className="text-2xl font-bold mb-8 text-center">Latest from Our Blog</h3>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {blogPosts.map((post, i) => (
        <div key={i} className="bg-gray-50 rounded-lg overflow-hidden shadow-sm">
          <div className="h-48 bg-gray-200">
            {/* Image placeholder */}
          </div>
          <div className="p-6">
            <h4 className="text-lg font-bold text-primary mb-2">{post.title}</h4>
            <p className="text-gray-700 mb-4">{post.summary}</p>
            <p className="text-sm text-gray-500">{post.date}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default BlogSection; 